import { useNearestDesignationsByCategoryQuery } from "react-migration/domains/constraints/designation/hooks/useNearestDesignationQuery";
import { useSelectionSidebarLoading } from "react-migration/layouts/map/Multilayer/Bundle/useSelectionSidebarLoadingState";
import { LayerTypeLayerSummaryProps } from "../../../../types";
import { SectionWithHeaderTooltip } from "../common/SectionWithHeaderTooltip";
import { useNearestSchoolsKeyIndicatorUS } from "./useNearestSchoolsKeyIndicatorUS";
import { RoundedCard, RoundedCardHeader } from "./RoundedCard";
import { AmenityDistanceInsight } from "./AmenityDistanceInsight";
import * as constants from "./constants";

type AmenitiesLayerSummaryUSProps = LayerTypeLayerSummaryProps;

export function AmenitiesLayerSummaryUS({ selection, onLoadingChange }: Readonly<AmenitiesLayerSummaryUSProps>) {
  const geometry = selection?.feature?.geometry;
  const { distanceLookup, loading, error } = useNearestDesignationsByCategoryQuery(
    geometry,
    constants.CLOSEST_AMENITY_RADIUSES_US
  );

  useSelectionSidebarLoading(onLoadingChange, loading);
  useNearestSchoolsKeyIndicatorUS(distanceLookup, constants.MAX_AMENITY_RADIUS_METERS);

  if (error) {
    throw error;
  }

  return (
    <SectionWithHeaderTooltip title="Educational institutions" tooltipText="Distance measured from site boundary">
      <RoundedCard>
        <div className="flex flex-col gap-1">
          <RoundedCardHeader>STATE</RoundedCardHeader>
          <div className="flex flex-col gap-2">
            <AmenityDistanceInsight
              subCategoryId={constants.US_SCHOOLS_ELEMENTARY_CATEGORY}
              designationDistance={distanceLookup.us_schools_elementary}
              loading={loading}
            />
            <AmenityDistanceInsight
              subCategoryId={constants.US_SCHOOLS_MIDDLE_CATEGORY}
              designationDistance={distanceLookup.us_schools_middle}
              loading={loading}
            />
            <AmenityDistanceInsight
              subCategoryId={constants.US_SCHOOLS_HIGH_CATEGORY}
              designationDistance={distanceLookup.us_schools_high}
              loading={loading}
            />
            <AmenityDistanceInsight
              subCategoryId={constants.US_SCHOOLS_COMBINATION_CATEGORY}
              designationDistance={distanceLookup.us_schools_combination}
              loading={loading}
            />
            <AmenityDistanceInsight
              subCategoryId={constants.US_SCHOOLS_OTHER_CATEGORY}
              designationDistance={distanceLookup.us_schools_other}
              loading={loading}
            />
          </div>
        </div>
      </RoundedCard>
      <RoundedCard>
        <div className="flex flex-col gap-1">
          <RoundedCardHeader>PRIVATE</RoundedCardHeader>
          <div className="flex flex-col gap-2">
            <AmenityDistanceInsight
              subCategoryId={constants.US_SCHOOLS_PRIVATE_ELEMENTARY_CATEGORY}
              designationDistance={distanceLookup.us_schools_private_elementary}
              loading={loading}
            />
            <AmenityDistanceInsight
              subCategoryId={constants.US_SCHOOLS_PRIVATE_SECONDARY_CATEGORY}
              designationDistance={distanceLookup.us_schools_private_secondary}
              loading={loading}
            />
            <AmenityDistanceInsight
              subCategoryId={constants.US_SCHOOLS_PRIVATE_COMBINED_CATEGORY}
              designationDistance={distanceLookup.us_schools_private_combined}
              loading={loading}
            />
          </div>
        </div>
      </RoundedCard>
    </SectionWithHeaderTooltip>
  );
}

AmenitiesLayerSummaryUS.icon = "icon-lt-graduation-cap-line";
AmenitiesLayerSummaryUS.title = "Nearest schools";
